import script from "./UploadPhotoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadPhotoView.vue?vue&type=script&setup=true&lang=ts"

import "./UploadPhotoView.vue?vue&type=style&index=0&id=07527561&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07527561"]])

export default __exports__